import AutoWithdraw from './AutoWithdraw'

export default AutoWithdraw
